module.exports = __webpack_public_path__ + "img/classic_print.73bd6d78.png";